export default __webpack_public_path__ + "static/media/5--240.f05ef219.jpg";